const TRANSCRIPTION = 'TRANSCRICAO';
const TRANSCRIPTION_CHECK = 'TRANSCR_CONFERENCIA';
const TRANSCRIPTION_PHARMACEUTICAL = 'TRANSCR_FARMACEUTICA';
const TRANSCRIPTION_APPROVED = 'TRANSCRICAO_APROVADA';

export {

  TRANSCRIPTION,
  TRANSCRIPTION_CHECK,
  TRANSCRIPTION_PHARMACEUTICAL,
  TRANSCRIPTION_APPROVED,
};